import React from 'react';
import classNames from 'classnames';
import { PrefixedInput } from '../dna';
import { ValidationResult } from '../../helpers/validation';
import { inputDNAClassNames, FieldProps } from '../../helpers/forms';
import { getCurrencyMessage } from 'src/helpers/currencyMap';

interface Props {
  targetAmount: FieldProps;
  targetCurrency: FieldProps;
  styles: Styles;
  prefix: string;
}
const AmountField: React.StatelessComponent<Props> = ({
  targetAmount,
  targetCurrency,
  styles,
  prefix,
}) => {
  return (
    <div className="dna-input-select-group">
      <div className="dna-form-field">
        <label className={classNames(styles.label)} htmlFor="target">
          Weʼre raising
        </label>
        <PrefixedInput
          {...targetAmount.input}
          id="target"
          type="number"
          min="2"
          max="9999999"
          prefix={prefix || '£'}
          className={inputDNAClassNames(
            {
              touched: targetAmount.meta.touched ? true : false,
              error: targetAmount.meta.error,
            },
            styles.target,
            'dna-input',
            'dna-input-text'
          )}
        />
        <ValidationResult
          touched={targetAmount.meta.touched}
          error={targetAmount.meta.error}
        />
        <p className={styles.note}>You can edit your target later.</p>
        <p className={styles.note}>
          {getCurrencyMessage(targetCurrency.input.value)}
        </p>
      </div>
    </div>
  );
};

export default AmountField;



// WEBPACK FOOTER //
// ./src/components/CreateForm/AmountField.tsx